import { render, staticRenderFns } from "./prenota.vue?vue&type=template&id=89b142e6&scoped=true"
import script from "./prenota.vue?vue&type=script&lang=js"
export * from "./prenota.vue?vue&type=script&lang=js"
import style0 from "./prenota.vue?vue&type=style&index=0&id=89b142e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b142e6",
  null
  
)

export default component.exports